/* MAC header basket count. The "Shop / N" count (snippets/cart.liquid) is server-rendered, so after any cart write
   made in the page (fetch or XHR to /cart/add, /cart/change, /cart/update, /cart/clear) re-read /cart.js and set
   every count on the page. Read-only: it never writes to the cart and never opens the drawer. */
(function(){
  'use strict';
  if (window.MacCartCount) return;
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null, seq = 0;
  function set(n){
    var t = n > 99 ? '99+' : String(n);
    document.querySelectorAll('.cart-count-text').forEach(function(e){ if (e.textContent.trim() !== t) e.textContent = t; });
    document.querySelectorAll('.custom-cart-btn[aria-label]').forEach(function(e){ e.setAttribute('aria-label', String(n)); });
    document.querySelectorAll('m-cart-count, .m-cart-count, .cart-count-bubble').forEach(function(e){
      e.textContent = t; e.classList.toggle('m:hidden', n === 0);
    });
  }
  function refresh(){
    var my = ++seq;
    return origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ if (my === seq && c && typeof c.item_count === 'number') set(c.item_count); })
      ['catch'](function(){});
  }
  function soon(){ clearTimeout(timer); timer = setTimeout(refresh, 120); }
  function isWrite(url, method){
    try { var u = new URL(url, location.href); return u.origin === location.origin && WRITE.test(u.pathname) && String(method || 'GET').toUpperCase() === 'POST'; }
    catch (e) { return false; }
  }
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || String(input);
      var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      var p = origFetch.apply(this, arguments);
      if (isWrite(url, method)) p.then(soon, soon);
      return p;
    };
  }
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u){ this.__macCart = isWrite(u, m); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(){ if (this.__macCart) this.addEventListener('loadend', soon); return XS.apply(this, arguments); };
  /* theme cart events and back/forward cache restores */
  ['cart:refresh', 'cart:updated', 'mac:basketemptied'].forEach(function(ev){ document.addEventListener(ev, soon); });
  window.addEventListener('pageshow', function(e){ if (e.persisted) soon(); });
  window.MacCartCount = { refresh: refresh, set: set };
})();
